import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { AppUserAccessActions, findUserAccessByAppId } from "./model";
import { isNullOrUndefined, isNullOrUndefinedOrEmpty } from "../../../../../../common/utils";
import {
  ApplicationDetailsActions,
  getSelectedColumns,
  getTotalColumns,
  usersTab,
} from "../../../model";
import { ColumnRepresentations } from "../../../../../../components/column-representations/model/ColumnRepresentations";

export const ApplicationUserAccessController = (appId, activeTabId) => {
  const dispatch = useDispatch();
  let dataSource = [];
  let columns = new ColumnRepresentations([]);
  let progress = null;
  const pinnedColumnsList = ["User"];

  const userAccesses = useSelector((rootState) =>
    findUserAccessByAppId(rootState.appUserAccess, appId)
  );
  let selectedColumns = useSelector((rootState) => getSelectedColumns(rootState.appDetails, appId));
  const totalColumns = useSelector((rootState) => getTotalColumns(rootState.appDetails, appId));

  if (userAccesses) {
    dataSource = userAccesses.data.value.dataSource;
    columns = new ColumnRepresentations(userAccesses.data.value.columns);
    progress = userAccesses.data.progress;
  }

  function columnSelect() {
    const totalColumnsFromUserAccess = columns.filterableColumns();
    if (totalColumnsFromUserAccess.length > 0) {
      selectedColumns = selectedColumns.filter((selectedColumn) => {
        return totalColumnsFromUserAccess.some((column) => column === selectedColumn);
      });
      if (totalColumns.length > 0) {
        selectedColumns = selectedColumns.concat(
          totalColumnsFromUserAccess.filter((column) => !totalColumns.includes(column))
        );
      }
      selectedColumns = selectedColumns.length > 0 ? selectedColumns : totalColumnsFromUserAccess;
      dispatch(
        ApplicationDetailsActions.setActiveColumns({
          appId,
          totalColumns: totalColumnsFromUserAccess,
          selectedColumns,
          pinnedColumns: columns.pinnedColumns(pinnedColumnsList),
        })
      );
    }
  }

  useEffect(() => {
    if (isNullOrUndefinedOrEmpty(dataSource) && !isNullOrUndefined(appId)) {
      dispatch(AppUserAccessActions.getApplicationUserAccess(appId));
    }
  }, [dispatch, appId]);

  function setPinnedColumnsOnClickingThisTab() {
    if (activeTabId === usersTab.id + "-" + appId) {
      columnSelect();
    }
  }

  useEffect(setPinnedColumnsOnClickingThisTab, [activeTabId, JSON.stringify(columns)]);

  return {
    dataSource,
    columns: columns.columnRepresentations,
    isLoading: !!progress,
    selectedColumns,
    totalColumns,
  };
};
